module.exports = __webpack_public_path__ + "static/media/LATimes.a1362dd7.png";